import React from "react";

export default function SectionF1 ({ order, left_score, left_short_name, firstName, lastName, team, driverNumber, timeString,nationalityCode, opta_event_url }) {
    return (
        <a className={"elementos-f1"} href={opta_event_url} target="_top">
        {/* <div className="elementos-f1"> */}
           
            <div className="nombres-f1">

                <div className="nombre-bandera">
                    <span className="posicion-f1">{order}</span>
                    <div className={"bandera bandera-"+nationalityCode} ></div>
                </div>

                <div className="nombre-f1">
                    <p className="firstLast-f1">{firstName} {lastName} </p>
                    <p className="nombre-team-f1">{team} #{driverNumber} </p>
                </div>
            </div>

            <div className="nombre-time-f1">{timeString}</div>
        {/* </div> */}
        </a>

    )
}